import { css, Theme } from '@emotion/react'

export const CHART_HEIGHT = 400

export const wrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  gap: 22px;

  margin: auto;
  padding: 20px;

  ${theme.breakpoints.up(768)} {
    padding: 10px 40px 40px;
    max-width: 1160px;
  }

  ${theme.breakpoints.up(1440)} {
    padding: 10px 48px 40px;
    max-width: 1176px;
  }
`

export const title = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const chartCard = (theme: Theme) => css`
  position: relative;

  width: 100%;
  border-radius: 16px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
`

export const cardTitle = (theme: Theme) => css`
  font-size: 16px;
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 700;
  line-height: normal;
`

export const cardHeading = css`
  display: flex;
  gap: 14px;
  justify-content: space-between;
  align-items: center;
  padding: 9px 13px;
`

export const headingTitles = css`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
`
